import React from "react";
import PropTypes from "prop-types";
import { EntityRow } from "../EntityRow";
import { Checkbox } from "../../../../shared/Checkbox/Checkbox";

const CommonAdditionally = ({
  isEnterCreditCard,
  onEnterCreditCardChange,
  isTextToPayVisible,
  isTextToPay,
  onTextToPayChange,
}) => (
  <EntityRow label="Additionally">
    <Checkbox
      name="card_data"
      isChecked={isEnterCreditCard}
      onChange={() => onEnterCreditCardChange(!isEnterCreditCard)}
      label="Enter Credit Card Details"
    />
    {/*
      Text to Pay and entering a card are alternatives, not additions: the patient
      either gives the card now or pays on the link. The container clears one when
      the other is checked.
    */}
    {isTextToPayVisible && (
      <Checkbox
        name="text_to_pay"
        isChecked={isTextToPay}
        onChange={() => onTextToPayChange(!isTextToPay)}
        label="Text to Pay (send payment link)"
      />
    )}
  </EntityRow>
);

CommonAdditionally.propTypes = {
  isEnterCreditCard: PropTypes.bool.isRequired,
  onEnterCreditCardChange: PropTypes.func.isRequired,
  isTextToPayVisible: PropTypes.bool,
  isTextToPay: PropTypes.bool,
  onTextToPayChange: PropTypes.func,
};

CommonAdditionally.defaultProps = {
  isTextToPayVisible: false,
  isTextToPay: false,
  onTextToPayChange: () => {},
};

export default CommonAdditionally;
